import React from 'react';
import { Card } from 'antd';
import { SkHeader, SkStatCards, SkTabsBar, SkFilterBar, SkTable, SkChartCard } from './_primitives';

/** AntiFraudPage — 8 stats, 4 tabs (alerts, patterns, metrics, blocked users), tables + charts */
const AntiFraudPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={2} />
    {/* 8 stat cards — 1 col mobile / 2 sm / 4 lg */}
    <SkStatCards count={8} />
    <Card className="shadow-sm">
      <SkTabsBar tabs={4} />
      <SkFilterBar filters={2} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        <SkChartCard height={220} />
        <SkChartCard height={220} />
      </div>
      <div className="overflow-x-auto">
        <SkTable rows={6} cols={7} inCard={false} />
      </div>
    </Card>
  </div>
);

export default AntiFraudPageLoader;
